export const IMAGE_PLACEHOLDER_COMPONENTS_TYPES = [
	'WPhoto',
	'ImageX',
	'ImageButton',
	'MediaPlayer',
	'StripColumnsContainer',
	'Column',
	'SlideShowSlide',
	'PageBackground',
	'HoverBox',
	'Section',
]
